import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const footerStyle = {
    backgroundColor: 'var(--navy-blue)',
    color: 'var(--white)',
    padding: '40px 0 20px',
    marginTop: '60px'
  };

  const footerContentStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '40px',
    marginBottom: '30px'
  };

  const footerSectionStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  };

  const footerTitleStyle = {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '16px',
    fontFamily: 'Comfortaa, cursive',
    color: 'var(--baby-blue)'
  };

  const footerLinkStyle = {
    color: 'var(--white)',
    textDecoration: 'none',
    fontSize: '14px',
    transition: 'color 0.3s ease'
  };

  const footerBottomStyle = {
    borderTop: '1px solid rgba(135, 206, 235, 0.3)',
    paddingTop: '20px',
    textAlign: 'center',
    fontSize: '14px',
    color: 'var(--gray-300)'
  };

  return (
    <footer style={footerStyle}>
      <div className="container">
        <div style={footerContentStyle}>
          <div style={footerSectionStyle}>
            <h3 style={footerTitleStyle}>Kolay Servis</h3>
            <p style={{ fontSize: '14px', lineHeight: '1.6' }}>
              Türkiye'nin en kapsamlı işletme rehberi. 
              Aradığınız hizmeti kolayca bulun, güvenilir firmalarla tanışın.
            </p>
          </div>

          <div style={footerSectionStyle}>
            <h4 style={footerTitleStyle}>Hızlı Linkler</h4>
            <Link to="/" style={footerLinkStyle}>Ana Sayfa</Link>
            <Link to="/firma-ekle" style={footerLinkStyle}>Firma Ekle</Link>
            <Link to="/iletisim" style={footerLinkStyle}>İletişim</Link>
            <Link to="/vizyonumuz" style={footerLinkStyle}>Vizyonumuz</Link>
          </div>

          <div style={footerSectionStyle}>
            <h4 style={footerTitleStyle}>Kategoriler</h4>
            <Link to="/kategori/1" style={footerLinkStyle}>Restoran & Cafe</Link>
            <Link to="/kategori/2" style={footerLinkStyle}>Sağlık Hizmetleri</Link>
            <Link to="/kategori/3" style={footerLinkStyle}>Eğitim</Link>
            <Link to="/kategori/4" style={footerLinkStyle}>Teknoloji</Link>
          </div>

          <div style={footerSectionStyle}>
            <h4 style={footerTitleStyle}>İletişim</h4>
            <p style={{ fontSize: '14px' }}>
              📧 info@kolayservis.com<br/>
              📞 0850 123 45 67<br/>
              📍 İstanbul, Türkiye
            </p>
          </div>
        </div>

        <div style={footerBottomStyle}>
          <p>&copy; 2024 Kolay Servis. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;